import React, { useEffect, useState } from 'react';

const styles = {
  container: { padding: '16px' },
  row: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' },
  select: { padding: '6px 10px' },
  button: { padding: '6px 12px' },
  results: { whiteSpace: 'pre-wrap', fontFamily: 'ui-monospace, Menlo, Consolas, monospace', background: '#fafafa', border: '1px solid #ddd', padding: '12px', minHeight: '180px' },
  label: { color: '#666' }
};

// 映射数据源到 sentences REST 端点
const dsToEndpoint = {
  vocabulary: 'vocabulary',
  sentence_pattern: 'sentence-pattern',
  vocab_example_sentence: 'vocabulary-example-sentences',
  vocabulary_extension: 'vocabulary-extensions',
};

// 工具
const toPrettyJSON = (obj) => JSON.stringify(obj, null, 2);
const fetchJSON = async (url) => {
  const resp = await fetch(url, { credentials: 'same-origin' });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json();
};

// 新增：媒体URL解析与类型判断（修复 localhost 到服务器主机）
// 媒体资源：不在官方域名下时（本地开发 / IP 访问）统一指向 HTTPS 域名，避免直连 8000
const MEDIA_ORIGIN = (typeof window !== 'undefined' && window.location &&
  window.location.hostname !== 'www.yangcongstudy.xin' && window.location.hostname !== 'yangcongstudy.xin')
  ? 'https://www.yangcongstudy.xin'
  : '';

const normalizeMediaPath = (u) => {
  if (!u) return '';
  let adjusted = u;
  if (!adjusted.startsWith('/')) adjusted = '/' + adjusted;
  if (!adjusted.startsWith('/media/')) {
    if (adjusted.includes('/media/')) {
      adjusted = adjusted.substring(adjusted.indexOf('/media/'));
    } else if (adjusted.includes('media/')) {
      adjusted = '/' + adjusted.substring(adjusted.indexOf('media/'));
    } else {
      adjusted = '/media/' + (adjusted.startsWith('/') ? adjusted.slice(1) : adjusted);
    }
  }
  return adjusted;
};

const resolveMediaUrl = (u) => {
  if (!u) return '';
  const lower = u.toLowerCase();
  const isAbsolute = lower.startsWith('http://') || lower.startsWith('https://');
  const isLocal8000 = lower.includes('localhost:8000') || lower.includes('127.0.0.1:8000');

  if (isAbsolute) {
    if (isLocal8000 && MEDIA_ORIGIN) {
      try {
        const urlObj = new URL(u);
        const path = urlObj.pathname + urlObj.search;
        return MEDIA_ORIGIN + path;
      } catch (e) {
        return u.replace('http://localhost:8000', MEDIA_ORIGIN).replace('http://127.0.0.1:8000', MEDIA_ORIGIN);
      }
    }
    return u;
  }
  const path = normalizeMediaPath(u);
  return MEDIA_ORIGIN ? (MEDIA_ORIGIN + path) : path;
};

const isVideoUrl = (u) => !!u && /(\.mp4|\.webm|\.ogg)(\?.*)?$/i.test(u);
const isImageUrl = (u) => !!u && /(\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.svg)(\?.*)?$/i.test(u);

// 相对路径，走 React devServer 代理：/api -> http://localhost:8000
// const SCENE_DIALOGUE_API = '/api/scene-dialogue/'; // 移除：避免引用 scene_dialogue
const SENTENCES_API = '/api/sentences/';
const ASKANDQUESTION_API = '/api/askandquestion/';

const SentencesTest = () => {
  const [apps, setApps] = useState([{ value: 'sentences', label: 'sentences' }, { value: 'askandquestion', label: 'askandquestion' }]);
  const [app, setApp] = useState('sentences');
  const [dataSources, setDataSources] = useState([]);
  const [ds, setDs] = useState('');
  const [results, setResults] = useState('');
  const [loading, setLoading] = useState(false);

  // sentences 分类与关联类型筛选
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [relationTypeOptions, setRelationTypeOptions] = useState([]);
  const [selectedRelationTypeId, setSelectedRelationTypeId] = useState('');

  // askandquestion 场景与问句类型筛选
  const [sceneOptions, setSceneOptions] = useState([]);
  const [selectedSceneId, setSelectedSceneId] = useState('');
  const [questionTypeOptions, setQuestionTypeOptions] = useState([]);
  const [selectedQuestionTypeId, setSelectedQuestionTypeId] = useState('');

  // Vocabulary 英文筛选
  const [vocabEnglishOptions, setVocabEnglishOptions] = useState([]);
  const [selectedVocabEnglish, setSelectedVocabEnglish] = useState('');

  // 关键词搜索（Vocabulary）
  const [keyword, setKeyword] = useState('');
  const [keywordSuggestions, setKeywordSuggestions] = useState([]);
  // QaPair ask_english 筛选
  const [qaAskEnglishOptions, setQaAskEnglishOptions] = useState([]);
  const [selectedQaAskEnglish, setSelectedQaAskEnglish] = useState('');
  // 答句列表（随选中的问句加载）
  const [qaAnswers, setQaAnswers] = useState([]);

  // 结果字段显示状态
  const [resultFields, setResultFields] = useState({
    // vocabulary 字段
    english: '',
    chinese: '',
    pronunciation_url: '',
    media_url: '',
    // qa-pairs 字段
    ask_english: '',
    ask_chinese: '',
    ask_pronunciation_url: '',

  });

  // Vocabulary 分页状态
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // 新增：步骤ID与当前选择信息（用于绑定到对话步骤）
  

  // 加载应用列表（改为静态，避免 404）
  const loadApps = async () => {
    setApps([{ value: 'sentences', label: 'sentences' }, { value: 'askandquestion', label: 'askandquestion' }]);
    setApp('sentences');
  };

  // 按应用加载数据源 +（对于 askandquestion 也加载场景/问句类型）
  const loadDataSourcesForApp = async (appVal) => {
    try {
      if (appVal === 'sentences') {
        const dss = [
          { value: 'vocabulary', label: '词汇（Vocabulary）' },
          { value: 'sentence_pattern', label: '句型（SentencePattern）' },
          { value: 'vocab_example_sentence', label: '词汇例句（VocabularyExampleSentence）' },
          { value: 'vocabulary_extension', label: '词汇扩展（VocabularyExtension）' },
        ];
        setDataSources(dss);
        setDs(dss[0].value);
        setCategoryOptions([]);
        setRelationTypeOptions([]);
      } else if (appVal === 'askandquestion') {
        const dss = [
          { value: 'qa-pairs', label: '问答对表（QaPair）' },

        ];
        setDataSources(dss);
        setDs(dss[0].value);
        // 加载场景与问句类型（来自 askandquestion 应用）
        const sceneResp = await fetchJSON(ASKANDQUESTION_API + 'scenes/?simplified=true&page_size=1000');
        const qtypeResp = await fetchJSON(ASKANDQUESTION_API + 'question-types/?simplified=true&page_size=1000');
        const scenes = Array.isArray(sceneResp.results) ? sceneResp.results : (Array.isArray(sceneResp) ? sceneResp : []);
        const qtypes = Array.isArray(qtypeResp.results) ? qtypeResp.results : (Array.isArray(qtypeResp) ? qtypeResp : []);
        setSceneOptions(scenes.map(s => ({ id: s.id, label: s.name || s.label || ('Scene #' + s.id) })));
        setQuestionTypeOptions(qtypes.map(q => ({ id: q.id, name: q.name || q.label || ('Type #' + q.id) })));
        setSelectedSceneId('');
        setSelectedQuestionTypeId('');
      } else {
        setDataSources([]);
        setDs('');
      }
    } catch (e) {
      // 出错时保底使用静态数据源
      if (appVal === 'sentences') {
        const fallback = [
          { value: 'vocabulary', label: '词汇（Vocabulary）' },
          { value: 'sentence_pattern', label: '句型（SentencePattern）' },
          { value: 'vocab_example_sentence', label: '词汇例句（VocabularyExampleSentence）' },
          { value: 'vocabulary_extension', label: '词汇扩展（VocabularyExtension）' },
        ];
        setDataSources(fallback);
        setDs(fallback[0].value);
      } else if (appVal === 'askandquestion') {
        const fallbackDs = [
          { value: 'qa-pairs', label: '问答对表（QaPair）' },
        ];
        setDataSources(fallbackDs);
        setDs(fallbackDs[0].value);
        setSceneOptions([]);
        setQuestionTypeOptions([]);
      } else {
        setDataSources([]);
        setDs('');
      }
    }
  };

  // 加载细化选项（分类/关联类型、场景/问句类型）
  const loadRefineOptions = async (appVal, dsVal) => {
    try {
      // 清空历史选择
      setSelectedCategoryId('');
      setSelectedRelationTypeId('');
      setSelectedSceneId('');
      setSelectedQuestionTypeId('');
  
      if (appVal === 'sentences') {
        if (dsVal === 'vocabulary' || dsVal === 'sentence_pattern') {
          const resp = await fetchJSON(SENTENCES_API + 'categories/?type=' + encodeURIComponent(dsVal) + '&ordering=order&page_size=1000');
          const cats = Array.isArray(resp.results) ? resp.results : (Array.isArray(resp) ? resp : []);
          const opts = cats.map(c => ({ id: c.id, label: c.name || c.label || ('Category #' + c.id) }));
          setCategoryOptions(opts);
        } else if (dsVal === 'vocabulary_extension') {
          // 动态聚合现有扩展词中的关联类型选项（使用id + display）
          const data = await fetchJSON(SENTENCES_API + 'vocabulary-extensions/?page_size=1000');
          const list = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
          const map = new Map();
          (list || []).forEach(item => {
            if (item && item.relation_type && item.relation_type_display) {
              map.set(item.relation_type, item.relation_type_display);
            }
          });
          const opts = Array.from(map.entries()).map(([id, name]) => ({ id, name }));
          setRelationTypeOptions(opts);
        } else {
          setCategoryOptions([]);
          setRelationTypeOptions([]);
        }
      } else if (appVal === 'askandquestion') {
        // 刷新场景与问句类型（来自 askandquestion 应用）
        const sceneResp = await fetchJSON(ASKANDQUESTION_API + 'scenes/?simplified=true&page_size=1000');
        const qtypeResp = await fetchJSON(ASKANDQUESTION_API + 'question-types/?simplified=true&page_size=1000');
        const scenes = Array.isArray(sceneResp.results) ? sceneResp.results : (Array.isArray(sceneResp) ? sceneResp : []);
        const qtypes = Array.isArray(qtypeResp.results) ? qtypeResp.results : (Array.isArray(qtypeResp) ? qtypeResp : []);
        setSceneOptions(Array.isArray(scenes) ? scenes.map(s => ({ id: s.id, label: s.name || s.label || ('Scene #' + s.id) })) : []);
        setQuestionTypeOptions(Array.isArray(qtypes) ? qtypes.map(q => ({ id: q.id, name: q.name || q.label || ('Type #' + q.id) })) : []);
      }
    } catch (e) {
      // 静默失败，不影响主流程
    }
  };

  // 查询（支持静默加载与仅更新英文选项）
  const search = (pageOverride, opts = {}) => {
    const { silent = false, dropdownOnly = false } = opts;
    try {
      if (!app || !ds) { if (!silent && !dropdownOnly) setResults('请先选择应用和数据表'); return; }
      if (app === 'sentences') {
        const endpoint = dsToEndpoint[ds];
        if (!endpoint) { if (!silent && !dropdownOnly) setResults('无效的数据表：' + ds); return; }
        const params = new URLSearchParams();
        params.set('ordering', 'id');
        params.set('page_size', '30');
        if (ds === 'vocabulary' || ds === 'sentence_pattern') {
          if (selectedCategoryId) params.set('categories__id', selectedCategoryId);
        }
        if (ds === 'vocabulary_extension') {
          if (selectedRelationTypeId) params.set('relation_type', selectedRelationTypeId);
        }
        // Vocabulary 精确英文过滤 + 分页（英文过滤时强制第1页；dropdownOnly不带英文）
         if (ds === 'vocabulary') {
           const isEnglishFilter = !!selectedVocabEnglish && !dropdownOnly;
           const pageParam = isEnglishFilter ? 1 : ((typeof pageOverride === 'number' && !Number.isNaN(pageOverride)) ? pageOverride : page);
           params.set('page', String(pageParam));
           if (isEnglishFilter) {
             params.set('english', selectedVocabEnglish.trim());
           }
         }
        const url = SENTENCES_API + endpoint + '/?' + params.toString();
        setLoading(true);
        if (!silent && !dropdownOnly) {
          setResults('正在查询 ' + app + '/' + endpoint + ' ...\nURL: ' + url);
        }
        fetchJSON(url)
          .then((data) => {
            if (ds === 'vocabulary') {
              const list = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
              let filtered = list;
              if (selectedVocabEnglish) filtered = list.filter(x => (x.english || '').trim() === selectedVocabEnglish.trim());
              const firstResult = filtered[0] || {};
              // 同步英文下拉选项为当前页或过滤后的结果
              const pageEnglish = Array.from(new Set((list || []).map(x => x.english).filter(Boolean)));
              const filteredEnglish = Array.from(new Set((filtered || []).map(x => x.english).filter(Boolean)));
              const count = typeof data.count === 'number' ? data.count : filtered.length;
              const pageParam = (typeof pageOverride === 'number' && !Number.isNaN(pageOverride)) ? pageOverride : page;

              if (dropdownOnly) {
                // 下拉/分页静默刷新：总是使用当前页的英文列表
                setVocabEnglishOptions(pageEnglish);
              } else {
                if (!selectedVocabEnglish) {
                  setVocabEnglishOptions(pageEnglish);
                } else {
                  setVocabEnglishOptions(filteredEnglish.length ? filteredEnglish : (pageEnglish.length ? pageEnglish : []));
                }
              }
              setTotalCount(count);
              setTotalPages(Math.max(1, Math.ceil(count / 30)));

              if (!dropdownOnly) {
                setResultFields(prev => ({
                  ...prev,
                  english: firstResult.english || '',
                  chinese: firstResult.chinese || '',
                  pronunciation_url: firstResult.pronunciation_url || '',
                  media_url: (firstResult.media_file_url || firstResult.image_url || '') || '',
                  ask_english: '', ask_chinese: '', ask_pronunciation_url: ''
                }));
                // 清空答句列表（仅 Vocabulary 模式）
                setQaAnswers([]);
                
                if (!silent) {
                  setResults(`找到 ${filtered.length} 条 Vocabulary 记录（总计 ${count}），当前第 ${pageParam} / ${Math.max(1, Math.ceil(count / 30))} 页，显示第一条结果`);
                }
                // 搜索后复原英文选择为“全部”，并静默刷新当前页下拉与分页（不带英文过滤）
                if (selectedVocabEnglish) {
                  const pageToRefresh = page; // 保持翻页前所在页
                  setSelectedVocabEnglish('');
                  setTimeout(() => {
                    search(pageToRefresh, { silent: true, dropdownOnly: true });
                  }, 0);
                }
              }
            } else {
              if (!dropdownOnly) {
                if (data && Array.isArray(data.results)) {
                  setResults(toPrettyJSON({ count: data.count, results: data.results }));
                } else {
                  setResults(toPrettyJSON(data));
                }
                // 新增：记录 askandquestion 当前选择（优先按筛选项匹配第一条）
                if (ds === 'qa-pairs') {
                  const list = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
                  let first = list[0] || null;
                  if (selectedQaAskEnglish) {
                    const filtered = list.filter(x => (x.ask_english || '').trim() === selectedQaAskEnglish.trim());
                    first = filtered[0] || first;
                  }
                  
                } else {

                }
              }
            }
          })
          .catch((e) => {
            if (!silent && !dropdownOnly) {
              setResults('查询失败：' + e.message + '\n\n提示：请确保后端在本机 8000 端口启动，并通过 React devServer 代理访问 /api。');
            }
          })
          .finally(() => {
            setLoading(false);
          });
      } else if (app === 'askandquestion') {
        const params = new URLSearchParams();
        params.set('ordering', 'id');
        if (selectedSceneId && selectedSceneId !== 'ALL') params.set('scene_id', selectedSceneId);
        if (selectedQuestionTypeId && selectedQuestionTypeId !== 'ALL') params.set('question_type_id', selectedQuestionTypeId);
        const base = ds === 'qa-pairs' ? 'qa-pairs' : ds;
        const url = ASKANDQUESTION_API + base + '/?' + params.toString();
        setLoading(true);
        if (!silent && !dropdownOnly) {
          setResults('正在查询 ' + app + '/' + base + ' ...\nURL: ' + url);
        }
        fetchJSON(url)
          .then((data) => {
            if (!dropdownOnly) {
              if (data && Array.isArray(data.results)) {
                setResults(toPrettyJSON({ count: data.count, results: data.results }));
              } else {
                setResults(toPrettyJSON(data));
              }
              // 新增：根据 askandquestion 当前数据源记录第一条选择，并填充结果字段
              const list = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
              let first = list[0] || null;
              if (ds === 'qa-pairs' && selectedQaAskEnglish) {
                const filtered = list.filter(x => (x.ask_english || '').trim() === selectedQaAskEnglish.trim());
                first = filtered[0] || first;
              }
              if (ds === 'qa-pairs') {
                 setResultFields(prev => ({
                   ...prev,
                   ask_english: (first && first.ask_english) || '',
                   ask_chinese: (first && first.ask_chinese) || '',
                   ask_pronunciation_url: (first && first.ask_pronunciation_url) || '',
                   english: '', chinese: '', pronunciation_url: '', media_url: ''
                 }));
                 // 拉取问答对详情，加载对应答句列表
                 if (first && first.id) {
                   fetchJSON(ASKANDQUESTION_API + 'qa-pairs/' + first.id + '/')
                     .then(detail => {
                       const ans = Array.isArray(detail.answers) ? detail.answers : [];
                       setQaAnswers(ans);
                     })
                     .catch(() => setQaAnswers([]));
                 } else {
                   setQaAnswers([]);
                 }
               }
               
             }
          })
          .catch((e) => {
            if (!silent && !dropdownOnly) {
              setResults('查询失败：' + e.message + '\n\n提示：请确保后端在本机 8000 端口启动，并通过 React devServer 代理访问 /api。');
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
    } catch (e) {
      if (!silent && !dropdownOnly) setResults('查询失败：' + e.message);
      setLoading(false);
    }
  };

  // 关键词搜索（不改变原有搜索逻辑，仅用于辅助定位英文）
  const searchKeyword = () => {
    try {
      if (app !== 'sentences' || ds !== 'vocabulary') {
        setResults('关键词搜索仅支持 Vocabulary');
        return;
      }
      const q = (keyword || '').trim();
      if (!q) {
        setResults('请输入关键词进行搜索');
        setKeywordSuggestions([]);
        return;
      }
      const params = new URLSearchParams();
      params.set('ordering', 'id');
      params.set('page', '1');
      params.set('page_size', '30');
      if (selectedCategoryId) params.set('categories__id', selectedCategoryId);
      params.set('search', q);
      const url = SENTENCES_API + 'vocabulary/?' + params.toString();
      setLoading(true);
      setResults('关键词搜索中...\nURL: ' + url);
      fetchJSON(url)
        .then((data) => {
          const list = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
          const uniqEnglish = Array.from(new Set((list || []).map(x => x.english).filter(Boolean)));
          setKeywordSuggestions(uniqEnglish);
          const count = typeof data.count === 'number' ? data.count : list.length;
          setResults(`关键词“${q}”匹配 ${list.length} 条（总计 ${count}）。请在下方选择建议词或用英文下拉选择后，点击上方“搜索”展示内容。`);
        })
        .catch((e) => {
          setResults('关键词搜索失败：' + e.message);
          setKeywordSuggestions([]);
        })
        .finally(() => setLoading(false));
    } catch (e) {
      setResults('关键词搜索失败：' + e.message);
      setLoading(false);
    }
  };


  useEffect(() => { loadApps(); }, []);
  useEffect(() => { if (app) loadDataSourcesForApp(app); }, [app]);
  useEffect(() => { if (app && ds) loadRefineOptions(app, ds); }, [app, ds]);
  // 当筛选发生变化时重置分页到第1页（不因英文选择变化而重置）
  useEffect(() => { setPage(1); }, [app, ds, selectedCategoryId]);

  // 分类变化时：重置英文选择，并仅更新英文选项与分页统计（不显示内容）
  useEffect(() => {
    if (app === 'sentences' && ds === 'vocabulary') {
      setSelectedVocabEnglish('');
      // 仅获取英文选项与分页统计，不更新结果显示
      search(1, { dropdownOnly: true });
    } else {
      setVocabEnglishOptions([]);
      setSelectedVocabEnglish('');
    }
  }, [app, ds, selectedCategoryId]);

  // 加载 QaPair 的 ask_english 选项（按场景/问句类型筛选）
  useEffect(() => {
    if (app === 'askandquestion' && ds === 'qa-pairs' && selectedSceneId) {
      let url = ASKANDQUESTION_API + 'qa-pairs/?page_size=1000';
      if (selectedSceneId !== 'ALL') {
        url += '&scene=' + encodeURIComponent(selectedSceneId) + '&include_descendants=true';
      }
      if (selectedQuestionTypeId && selectedQuestionTypeId !== 'ALL') {
        url += '&question_type=' + encodeURIComponent(selectedQuestionTypeId);
      }
      fetchJSON(url)
        .then(data => {
          const list = Array.isArray(data.results) ? data.results : (Array.isArray(data) ? data : []);
          const uniq = Array.from(new Set((list || []).map(x => x.ask_english).filter(Boolean)));
          setQaAskEnglishOptions(uniq);
        })
        .catch(() => setQaAskEnglishOptions([]));
    } else {
      setQaAskEnglishOptions([]);
      setSelectedQaAskEnglish('');
      setQaAnswers([]);
    }
  }, [app, ds, selectedSceneId, selectedQuestionTypeId]);

  return (
    <div style={styles.container}>
      <h3>Sentences / AskAndQuestion 接口测试</h3>
      <div style={styles.row}>
        <span style={styles.label}>应用：</span>
        <select style={styles.select} value={app} onChange={(e) => setApp(e.target.value)}>
          {apps.map(a => (<option key={a.value} value={a.value}>{a.label}</option>))}
        </select>
        <span style={styles.label}>数据表：</span>
        <select style={styles.select} value={ds} onChange={(e) => setDs(e.target.value)}>
          {dataSources.map(x => (<option key={x.value} value={x.value}>{x.label}</option>))}
        </select>
        <button style={styles.button} type="button" onClick={() => search(undefined, { silent: false })} disabled={loading}>{loading ? '查询中...' : '搜索'}</button>
      </div>

      {/* 细化筛选区域 */}
      {app === 'sentences' && (ds === 'vocabulary' || ds === 'sentence_pattern') && (
        <div style={styles.row}>
          <span style={styles.label}>分类：</span>
          <select style={styles.select} value={selectedCategoryId} onChange={(e) => setSelectedCategoryId(e.target.value)}>
            <option value="">请选择分类</option>
            {categoryOptions.map(o => (<option key={o.id} value={o.id}>{o.label || o.name}</option>))}
          </select>
        </div>
      )}

      {app === 'sentences' && ds === 'vocabulary' && (
        <>
          <div style={styles.row}>
            <span style={styles.label}>关键词搜索：</span>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入英文或中文关键词"
              style={{ ...styles.select, minWidth: '220px' }}
            />
            <button type="button" style={styles.button} onClick={searchKeyword} disabled={loading}>
              {loading ? '查询中...' : '按关键词搜索'}
            </button>
          </div>
          {keywordSuggestions && keywordSuggestions.length > 0 && (
            <div style={styles.row}>
              <span style={styles.label}>建议：</span>
              <select
                style={styles.select}
                value={selectedVocabEnglish}
                onChange={(e) => setSelectedVocabEnglish(e.target.value)}
              >
                <option value="">请选择一个建议词</option>
                {keywordSuggestions.slice(0, 50).map(v => (
                  <option key={v} value={v}>{v}</option>
                ))}
              </select>
              <button type="button" style={styles.button} onClick={() => setKeywordSuggestions([])}>清空建议</button>
              <span style={{ ...styles.label, color: '#999' }}>选中后点击上方“搜索”展示内容</span>
            </div>
          )}
          <div style={styles.row}>
            <span style={styles.label}>英文（Vocabulary english）：</span>
            <select style={styles.select} value={selectedVocabEnglish} onChange={(e) => setSelectedVocabEnglish(e.target.value)}>
              <option value="">全部</option>
              {vocabEnglishOptions.map(v => (<option key={v} value={v}>{v}</option>))}
            </select>
          </div>
          {!selectedVocabEnglish && (
            <div style={styles.row}>
              <span style={styles.label}>分页：</span>
              <button type="button" style={styles.button} onClick={() => { const prev = Math.max(1, page - 1); if (prev !== page) { setSelectedVocabEnglish(''); setPage(prev); search(prev, { silent: true, dropdownOnly: true }); } }} disabled={loading || page <= 1}>上一页</button>
              <button type="button" style={styles.button} onClick={() => { const next = page + 1; setSelectedVocabEnglish(''); setPage(next); search(next, { silent: true, dropdownOnly: true }); }} disabled={loading || (totalPages > 0 && page >= totalPages)}>下一页</button>
              <span style={styles.label}>当前 {page} / {Math.max(1, totalPages)} 页（每页 30 条，总计 {totalCount}）</span>
            </div>
          )}
        </>
      )}

      {app === 'sentences' && ds === 'vocabulary_extension' && (
        <div style={styles.row}>
          <span style={styles.label}>关联类型管理：</span>
          <select style={styles.select} value={selectedRelationTypeId} onChange={(e) => setSelectedRelationTypeId(e.target.value)}>
            <option value="">请选择关联类型</option>
            {relationTypeOptions.map(rt => (<option key={rt.id} value={rt.id}>{rt.name}</option>))}
          </select>
        </div>
      )}

      {app === 'askandquestion' && (
        <div style={{ ...styles.row, flexWrap: 'wrap' }}>
          <span style={styles.label}>场景分类管理：</span>
          <select style={styles.select} value={selectedSceneId} onChange={(e) => setSelectedSceneId(e.target.value)}>
            <option value="">请选择场景</option>
            <option value="ALL">全部</option>
            {sceneOptions.map(s => (<option key={s.id} value={s.id}>{s.label}</option>))}
          </select>
          <span style={{ ...styles.label, marginLeft: '16px' }}>问句类型管理：</span>
          <select style={styles.select} value={selectedQuestionTypeId} onChange={(e) => setSelectedQuestionTypeId(e.target.value)}>
            <option value="">可选：请选择问句类型</option>
            <option value="ALL">全部</option>
            {questionTypeOptions.map(q => (<option key={q.id} value={q.id}>{q.name}</option>))}
          </select>
        </div>
      )}

      {app === 'askandquestion' && ds === 'qa-pairs' && (
        <div style={styles.row}>
          <span style={styles.label}>问句英文（ask_english）：</span>
          <select style={styles.select} value={selectedQaAskEnglish} onChange={(e) => setSelectedQaAskEnglish(e.target.value)}>
            <option value="">全部</option>
            {qaAskEnglishOptions.map(v => (<option key={v} value={v}>{v}</option>))}
          </select>
        </div>
      )}

      {/* 结果字段显示区域 */}
      <div style={{ border: '1px solid #ddd', padding: '16px', background: '#f9f9f9' }}>
        <h4 style={{ margin: '0 0 12px 0', color: '#333' }}>搜索结果字段：</h4>
        
        {/* Vocabulary 字段 (sentences 应用) */}
        {app === 'sentences' && ds === 'vocabulary' && (
          <div>
            <div style={styles.row}>
              <span style={{ ...styles.label, minWidth: '120px' }}>英文 (english)：</span>
              <input 
                type="text" 
                value={resultFields.english} 
                readOnly 
                style={{ ...styles.select, flex: 1, background: '#fff' }}
              />
            </div>
            <div style={styles.row}>
              <span style={{ ...styles.label, minWidth: '120px' }}>中文 (chinese)：</span>
              <input 
                type="text" 
                value={resultFields.chinese} 
                readOnly 
                style={{ ...styles.select, flex: 1, background: '#fff' }}
              />
            </div>
            <div style={{ ...styles.row, alignItems: 'flex-start' }}>
              <span style={{ ...styles.label, minWidth: '120px' }}>发音 (pronunciation_url)：</span>
              <div style={{ flex: 1 }}>
                <input 
                  type="text" 
                  value={resultFields.pronunciation_url} 
                  readOnly 
                  style={{ ...styles.select, width: '100%', background: '#fff', marginBottom: '6px' }}
                />
                {resultFields.pronunciation_url && (
                  <audio
                    controls
                    src={resolveMediaUrl(resultFields.pronunciation_url)}
                    style={{ maxWidth: '320px' }}
                  />
                )}
              </div>
            </div>
            <div style={{ ...styles.row, alignItems: 'flex-start' }}>
              <span style={{ ...styles.label, minWidth: '120px' }}>媒体 (图片或视频)：</span>
              <div style={{ flex: 1 }}>
                <input 
                  type="text" 
                  value={resultFields.media_url} 
                  readOnly 
                  style={{ ...styles.select, width: '100%', background: '#fff', marginBottom: '6px' }}
                />
                {resultFields.media_url && (
                  isVideoUrl(resultFields.media_url) ? (
                    <video
                      controls
                      src={resolveMediaUrl(resultFields.media_url)}
                      style={{ maxWidth: '320px', maxHeight: '240px', borderRadius: '6px' }}
                    />
                  ) : (
                    isImageUrl(resultFields.media_url) ? (
                      <img
                        src={resolveMediaUrl(resultFields.media_url)}
                        alt={resultFields.english || '词汇媒体'}
                        style={{ maxWidth: '320px', maxHeight: '240px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.08)' }}
                      />
                    ) : (
                      <div style={{ color: '#999', fontStyle: 'italic' }}>不支持的媒体格式</div>
                    )
                  )
                )}
              </div>
            </div>
          </div>
        )}

        {/* QaPair 字段 (askandquestion 应用) */}
        {app === 'askandquestion' && ds === 'qa-pairs' && (
          <div>
            <div style={styles.row}>
              <span style={{ ...styles.label, minWidth: '120px' }}>问句英文 (ask_english)：</span>
              <input 
                type="text" 
                value={resultFields.ask_english} 
                readOnly 
                style={{ ...styles.select, flex: 1, background: '#fff' }}
              />
            </div>
            <div style={styles.row}>
              <span style={{ ...styles.label, minWidth: '120px' }}>问句中文 (ask_chinese)：</span>
              <input 
                type="text" 
                value={resultFields.ask_chinese} 
                readOnly 
                style={{ ...styles.select, flex: 1, background: '#fff' }}
              />
            </div>
            <div style={{ ...styles.row, alignItems: 'flex-start' }}>
              <span style={{ ...styles.label, minWidth: '120px' }}>问句发音 (ask_pronunciation_url)：</span>
              <div style={{ flex: 1 }}>
                <input 
                  type="text" 
                  value={resultFields.ask_pronunciation_url} 
                  readOnly 
                  style={{ ...styles.select, width: '100%', background: '#fff', marginBottom: '6px' }}
                />
                {resultFields.ask_pronunciation_url && (
                  <audio
                    controls
                    src={resolveMediaUrl(resultFields.ask_pronunciation_url)}
                    style={{ maxWidth: '320px' }}
                  />
                )}
              </div>
            </div>

            {/* 答句列表（来自 qaAnswers） */}
            <div style={{ marginTop: '12px' }}>
              <h5 style={{ margin: '8px 0', color: '#333' }}>答句列表：</h5>
              {(!qaAnswers || qaAnswers.length === 0) ? (
                <div style={{ color: '#999' }}>当前问句暂无关联答句</div>
              ) : (
                qaAnswers.map((ans) => (
                  <div key={ans.id || ans.answer_english} style={{ borderTop: '1px dashed #ddd', paddingTop: '8px', marginTop: '8px' }}>
                    <div style={styles.row}>
                      <span style={{ ...styles.label, minWidth: '120px' }}>答句英文：</span>
                      <input type="text" value={ans.answer_english || ''} readOnly style={{ ...styles.select, flex: 1, background: '#fff' }} />
                    </div>
                    <div style={styles.row}>
                      <span style={{ ...styles.label, minWidth: '120px' }}>答句中文：</span>
                      <input type="text" value={ans.answer_chinese || ''} readOnly style={{ ...styles.select, flex: 1, background: '#fff' }} />
                    </div>
                    <div style={{ ...styles.row, alignItems: 'flex-start' }}>
                      <span style={{ ...styles.label, minWidth: '120px' }}>答句发音：</span>
                      <div style={{ flex: 1 }}>
                        <input type="text" value={ans.answer_pronunciation_url || ''} readOnly style={{ ...styles.select, width: '100%', background: '#fff', marginBottom: '6px' }} />
                        {ans.answer_pronunciation_url && (
                          <audio controls src={resolveMediaUrl(ans.answer_pronunciation_url)} style={{ maxWidth: '320px' }} />
                        )}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}


        {/* 其他数据源显示原始结果 */}
        {((app === 'sentences' && !['vocabulary'].includes(ds)) || 
          (app === 'askandquestion' && !['qa-pairs'].includes(ds))) && (
          <div style={{ color: '#666', fontStyle: 'italic' }}>
            此数据源暂时使用上方的文本框显示结果
          </div>
        )}
      </div>
    </div>
  );
};

export default SentencesTest;